module.exports = __webpack_public_path__ + "static/media/me.edac7f9a.jpg";